import { useState, useEffect, useRef } from 'react';
import useAuth from './hooks/useAuth';
import VideoPlayer from './VideoPlayer';
import parte_1_thumb from '../images/thumbs/parte_1_thumb.png'
import parte_2_thumb from '../images/thumbs/parte_2_thumb.png'
import parte_3_thumb from '../images/thumbs/parte_3_thumb.png'
import parte_4_thumb from '../images/thumbs/parte_4_thumb.png'
import parte_5_thumb from '../images/thumbs/parte_5_thumb.png'
import parte_6_thumb from '../images/thumbs/parte_6_thumb.png'
import parte_7_thumb from '../images/thumbs/parte_7_thumb.png'
import parte_8_thumb from '../images/thumbs/parte_8_thumb.png'
import LockIcon from '@mui/icons-material/Lock';
import { isSafari } from 'react-device-detect'
import {db, storage} from './firebase'
import {collection, getDocs} from 'firebase/firestore'
import {getDownloadURL, ref} from 'firebase/storage'
import axios from 'axios';
import { BASE_URL } from './utils/Scripts'

export function VideoThumb(props:any){
    const [thumb, setThumb] = useState('')
    async function getThumb(){
        const new_thumb = await getDownloadURL(ref(storage,'thumbs/'+props.thumb))
        setThumb(new_thumb)
    }
    useEffect(()=>{
        getThumb()
    },[])
    return(
        <div style={{float:'left', width:80*16/9, height:'80px', marginTop:'10px', backgroundImage:`url('${thumb}')`, backgroundSize:'cover'}}>
            {!props.isAllowed&&(
            <div style={{backgroundColor:"rgba(0,0,0,0.6)", height:'100%', width:'100%'}}>
                <div style={{color:"#fff", position:'relative', top:'50%', transform:'translateY(-50%)'}}>
                    <LockIcon style={{transform:'scale(1.3)'}}/>
                </div>
            </div>
            )}
        </div>
    )
}

export function SelectedVideo(props:any){
    const video = props.video
    const [currentId, setCurrentId] = useState(video.parts[0].id)
    const [thumb, setThumb] = useState('')
    async function getThumb(){
        const new_thumb = await getDownloadURL(ref(storage,'thumbs/'+video.main_thumb))
        setThumb(new_thumb)
    }
    useEffect(()=>{
        getThumb()
    },[])

    const {auth}:any = useAuth()

    function isAllowed(){
        let allowed = false
        if(auth.roles.includes(1)){
            allowed = true
        }
        return(allowed)
    }

    const HLS_URL =(id:any)=> 'https://vz-93c1c9db-985.b-cdn.net/'+id+'/playlist.m3u8'
    

    function videoJsOptions(id:string) {
        return(
            {            autoplay: false,
            controls: true,
            responsive: true,
            fluid: true,
            playbackRates: [1, 1.5, 2],
            sources: [{
                src: HLS_URL(id),
                type: 'application/x-mpegURL'
            }]}
        )
    }


    return(
        <div>
            <div style={{float:props.mobile?'none':'left', overflow:'hidden', borderRadius:props.mobile?'0px':'10px', position:props.mobile?'absolute':'relative',left:'0'}}>
                {isAllowed()
                ?
                <VideoPlayer options={videoJsOptions(currentId)} width={props.mobile?'100vw':'60vw'}/>
                // <iframe style={{border:'none'}} width={props.mobile?props.width:props.width*0.6} height={props.mobile?props.width*9/16:props.width*0.6*9/16} src={"https://www.youtube.com/embed/"+currentId} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                :
                <div style={{width:props.mobile?'100vw':'60vw', height:props.mobile?(props.width)/16*9:(props.width*0.6)/16*9, backgroundImage:'url('+thumb+')', backgroundSize:'cover'}}></div>
                }
                
            </div>
            <div style={{float:props.mobile?'none':'left', height:props.mobile?'':(props.width*0.6)/16*9, width:props.mobile?'80vw':'20vw', marginLeft:props.mobile?'0px':'50px', overflowY:props.mobile?'hidden':'scroll', transform:props.mobile?'translateY('+(((props.width)/16*9)+10)+'px)':''}}>
                {video.parts.map((part:any, key:any)=>{
                        return(
                            <div className={currentId==part.video_id?'videoSelected':'videoPart'} key={key} style={{
                                color:"#fff",
                                cursor:'pointer',
                                height:'100px',
                            }} onClick={()=>{setCurrentId(part.id)}}>
                                {/* <div style={{float:'left', width:80*16/9, height:'80px', marginTop:'10px', backgroundImage:`url('${''}')`, backgroundSize:'cover'}}>
                                    {!isAllowed()&&(
                                    <div style={{backgroundColor:"rgba(0,0,0,0.6)", height:'100%', width:'100%'}}>
                                        <div style={{color:"#fff", position:'relative', top:'50%', transform:'translateY(-50%)'}}>
                                            <LockIcon style={{transform:'scale(1.3)'}}/>
                                        </div>
                                    </div>
                                    )}
                                </div> */}
                                <VideoThumb isAllowed={isAllowed()} thumb={part.thumb}/>
                                <div style={{float:'left', position:'relative', top:'50%', transform:'translateY(-50%)', marginLeft:'10px'}}>
                                    Parte {key+1} de {video.parts.length}
                                </div>
                                <div style={{clear:'both'}}/>

                            </div>
                        )
                })}
            </div>
            <div style={{clear:'both'}}/>
        </div>
    )
}

export function MainVideoThumb(props:any){

    const [thumb, setThumb] = useState('')
    async function getThumb(){
        const new_thumb = await getDownloadURL(ref(storage,'thumbs/'+props.thumb))
        setThumb(new_thumb)
    }
    useEffect(()=>{
        getThumb()
    },[])

    const wid = props.mobile?0.8*props.width:350
    
    return(
        <div style={{width:wid+'px',height:wid*9/16+'px', backgroundImage:`url('${thumb}')`, backgroundSize:'cover', borderRadius:'8px'}}/>
    )
}

export function PlaylistVideo(props:any){
    const [videos, setVideos] = useState<any>([])
    const [selected, setSelected] = useState({})

    async function getVideos(){
        const options ={
            url:BASE_URL+'arcalab_firestore',
            method:'POST',
            headers: {
                accept: 'application/json',
                'content-type': 'application/json',
            },
            data:{
                type:'getDocs',
                collection:'arcalab_videos'
            }
        }
        const snapshot:any = await axios(options)
        let videos_var:any = []
        let index = 0
        console.log(snapshot.data)
        snapshot.data.map(async(doc:any)=>{
            index++
            const title = doc.data.title
            const date = doc.data.date
            const main_thumb = doc.data.main_thumb
            const description = doc.data.description
            const subjects = doc.data.subjects
            const dateStringToTimestamp = (dateString:any) =>{
                const [day, month, year] = dateString.split('/').map(Number)
                const date = new Date(year, month-1, day)
                return(date.getTime())
            }
            const timestamp = dateStringToTimestamp(date)
            const duration = doc.data.duration
            let parts = []
            for(let a=0;a<doc.data.videos.length;a++){
                // const thumb = await getDownloadURL(ref(storage, 'thumbs/'+doc.data().videos[a].thumb))
                parts.push({
                        id:doc.data.videos[a].id,
                        // thumb:thumb,
                        thumb:doc.data.videos[a].thumb,
                        title:doc.data.videos[a].title
                })
            }
            const object = {
                title:title,
                id:doc.id,
                date:date,
                timestamp:timestamp,
                main_thumb:main_thumb,
                description:description,
                subjects:subjects,
                duration:duration,
                parts:parts,
            }
            videos_var.push(object)
            if(index==snapshot.data.length){
                const sorted_var = videos_var.sort(((a:any,b:any)=>b.timestamp-a.timestamp))
                setVideos(sorted_var)
            }
        })
    }

    useEffect(()=>{
        if(videos.length==0){
            getVideos()
        }
    },[])
    return(
        <div>
            {Object.keys(selected).length>0&&(<SelectedVideo width={props.width} mobile={props.mobile} video={selected}/>)}
            {Object.keys(selected).length==0&&(
            <div style={{display:'flex', justifyContent:'center', flexDirection:props.mobile&&('column')}}>
                {videos.map((video:any, index:any)=>{
                    return(
                        <div key={index} style={{color:"#fff", width:props.mobile?'100%':'350px', cursor:'pointer', display:'flex', justifyContent:'left', flexDirection:'column', textAlign:'left', marginRight:'20px', marginBottom:props.mobile&&('20px')}} onClick={()=>{setSelected(video)}}>
                            <MainVideoThumb thumb={video.main_thumb} mobile={props.mobile} width={props.width}/>
                            <div style={{fontWeight:'600', fontSize:'15px', fontFamily:'Digital', color:"#ececec", marginTop:'6px'}}>
                                {video.title.toUpperCase()}
                            </div>
                            <div style={{display:'flex', alignItems:'center'}}>
                                <div style={{backgroundColor:'#333', borderRadius:'4px', display:'inline-block', width:'fitContent',padding:'1px 3px',fontSize:'10px', border:'1px solid #444', marginBottom:'3px', color:'#cdcdcd', transform:'translateY(2px)'}}>{video.date}</div>
                                <div style={{fontSize:'11px', fontWeight:'500', marginLeft:'5px', color:'#777'}}>{video.duration}</div>
                            </div>
                            <div>
                                {video.description}
                            </div>
                            <div>
                                {video.subjects.map((sub:any, index:any)=>{
                                    return(
                                        <div key={index} style={{backgroundColor:'#333', borderRadius:'4px', display:'inline-block', width:'fitContent',padding:'1px 3px',marginLeft:index>0?'3px':'', marginTop:'3px', fontSize:'10px', border:'1px solid #444', color:'#cdcdcd'}}>
                                            {sub}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                })}
            </div>)}
        </div>
    )
    
}